export enum SubTypesEnums {
  regular = "regular",
  "cool/rare" = "cool/rare",
  exclusive = "exclusive",
}
export const SubTypeLabels: Record<SubTypesEnums, string> = {
  [SubTypesEnums.regular]: "Regular",
  [SubTypesEnums["cool/rare"]]: "Cool / Rare",
  [SubTypesEnums.exclusive]: "Exclusive",
};
